<template>
  <div class="t-lk-tablet-menu" :class="{ active: visible }">
    <div class="t-lk-tablet-menu__header t-lk-tablet-menu-header">
      <div class="t-lk-tablet-menu-header__user-wrapper" v-click-outside="() => (showUserMenu = false)">
        <div class="t-lk-tablet-menu-header__user" :class="{ _open: showUserMenu }" @click="toggleUserMenu">
          <div class="t-lk-tablet-menu-header__user-name">
            <span>{{ profile.name }}&nbsp;</span>
            <span>{{ profile.surname }}</span>
          </div>
          <TriangleFilledSvg class="t-lk-tablet-menu-header__arrow" />
        </div>
        <transition name="fade">
          <div v-if="showUserMenu" class="t-lk-tablet-menu-header__dropdown-list">
            <router-link @click="$emit('change', false)" :to="{ name: 'lk-security' }" class="t-lk-tablet-menu-header__dropdown-item">
              {{ $root.staticText.lk.settings }}
            </router-link>
            <a :href="linkLogout" class="t-lk-tablet-menu-header__dropdown-item">
              {{ $root.staticText.lk.logout }}
            </a>
          </div>
        </transition>
      </div>

      <locale v-if="isMobile" class="t-lk-tablet-header__locale" />
    </div>

    <div class="t-lk-tablet-menu__main">
      <ul class="t-lk-tablet-menu__menu-list">
        <li v-for="(menuItem, idx) in menu" :key="menuItem.name" class="t-lk-tablet-menu__menu-item">
          <template v-if="hasSubMenu(menuItem)">
            <button
              :class="['t-lk-tablet-menu__menu-btn', { 't-lk-tablet-menu__menu-btn--active': activeMenuIdx === idx }]"
              :aria-label="menuItem.name"
              @click="toggleActiveMenuIdx(idx)"
            >
              {{ menuItem.name }}
              <TriangleFilledSvg class="t-lk-tablet-menu__menu-icon-direction" />
            </button>
            <ul v-if="activeMenuIdx === idx" class="t-lk-tablet-menu__sub-menu" role="menu">
              <li v-for="submenu in menuItem.submenu" :key="submenu.name" class="t-lk-tablet-menu__sub-menu-item">
                <t-link class="t-lk-tablet-menu__sub-menu-link" :link="submenu.link">
                  {{ submenu.name }}
                </t-link>
              </li>
            </ul>
          </template>
          <template v-else>
            <t-link class="t-lk-tablet-menu__menu-link" :link="menuItem.link">
              {{ menuItem.name }}
            </t-link>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import locale from "@components/base/locale"
import TriangleFilledSvg from "@assets/lk/img/TriangleFilled.svg?inline"
import tLink from "@components/ui-components/t-link"

export default {
  name: "lk-tablet-menu",
  components: {
    locale,
    tLink,
    TriangleFilledSvg,
  },
  model: {
    prop: "visible",
    event: "input",
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    menu: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      showUserMenu: false,
      activeMenuIdx: null,
    }
  },
  computed: {
    ...mapState("mobile", ["isTabletMenuVisible", "isMobileMenuVisible", "isMobile", "isTablet"]),
    ...mapGetters("lk", ["profile", "linkLogout"]),
  },
  methods: {
    // (item: object): bool
    hasSubMenu(item) {
      return !!item?.submenu
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
    },
    // (idx: number):
    toggleActiveMenuIdx(idx) {
      if (idx === this.activeMenuIdx) this.unsetActiveMenuIdx()
      else this.setActiveMenuIdx(idx)
    },
    setActiveMenuIdx(idx) {
      this.activeMenuIdx = idx
    },
    unsetActiveMenuIdx() {
      this.activeMenuIdx = null
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-tablet-menu/lk-tablet-menu.vue